import Review from './review'

const ruleDisplay = (d) => {
  return `${d['billing.clearingTypeText']}：￥${d['billing.stagesPrice']} x ${d['billing.stagesNum']} 期`
}

const equal = (a , b) => {
  if(a == b) return true
  if((a == null || a == undefined || a == '') && (b == null || b == undefined || b == '')) return true
  return false
}

export default {
  props: ['carNo' , 'reviewable' , 'data' , 'id'],
  data(){
    return {
      approvalId:null,
      raw:{},
      target:[],
      origin:[]
    }
  },
  created(){
    if(this.data){
      this.setData(this.data)
    }else if(this.id){
      this.$request.carCommit(this.id).then(resp => {
        if( resp.code ){
          this.$Message.error(resp.msg)
        }else{
          this.setData(resp.data)
        }
      })
    }else if(this.carNo){
      this.$request.carLastCommit(this.carNo).then(resp => {
        if( resp.code ){
          this.$Message.error(resp.msg)
        }else{
          this.setData(resp.data)
        }
      })
    }
  },
  methods:{

    setData(data){
      this.raw = this.$utils.conv(data,{'applyStatus':'carReviewState'})
      this.approvalId = data.id
      this.target = this.conv( data.targetCarInfo || {})
      this.origin = this.conv( data.originalCarInfo || {})
    },

    conv(data){
      data = this.$utils.conv(this.$utils.flat(data) , {
        'enrollDatetime':'date',
        'buyOptions':'buyOptions',
        'battery.type':'batteryType',
        'billing.clearingType':'clearingType',
        ruleDisplay
      })
      return data
    },
    review(){
      this.$dialog({
        title: '审核',
        width: 550,
        paddingless: true,
        render: (h) => {
          return <Review id={this.approvalId} />
        },
        onOk: () => {
          // this.query()
          this.$emit('ok' , true)
        }
      })
    },
    diff(key){
      let { target = {} , origin = {} } = this
      if( target[key] !== origin[key] ){
        return { color:'#fa795e'}
      }else{
        return {}
      }
    },
    renderItem(key){
      const data = this.target || {}
      const origin = this.origin || {}
      let a = origin[key] , b = data[key]
      if(equal(a,b)) return a
      else return <div style="display:flex;align-items: center;"><div style="width:200px">{a}</div><Icon type="md-arrow-forward" style="margin:0 16px;" /><div>{b}</div></div>
    },
    renderTip(){
      //备案审核状态 审批状态：0、已提交(审核中)；1、已通过；2、已拒绝；3、已取消

      let colors = ['#2d8cf0','#19be6b','#ed4014','#999']
      let color = '#999'
      if(this.raw.applyStatus !== null){
        color = colors[this.raw.applyStatus]
      }
      let style = `position:absolute;z-index:1;right:50px;top:100px;border:2px solid ${color};font-size:20px;color:${color};transform: rotate(26deg);opacity: 0.618;padding: 8px 24px`
      return  <div style={style}>{this.raw.applyStatusText}</div>

    }
  },
  render() {
    const diff = this.diff
    const data = this.target || {}
    const origin = this.origin || {}

    const footer = this.reviewable ? <div class="modal-footer">
          <Button on-click={this.review} type="primary">审核</Button>
        </div> : null
    const renderItem = this.renderItem
    return (
      <div>
        <div class="modal-body">
          {this.renderTip()}
          {
            this.raw.applyStatus == 2 ? <Alert type="error">已拒绝：{this.raw.approvalFlowDetail.reason}</Alert> : null

          }
          <div style="display:flex;">
            <sl-detail-list label-width="120px" col={1} label-align="right">
              <sl-detail-list-item labelStyle={diff('certNo')} title="合格证编号">{renderItem('certNo')}</sl-detail-list-item>
              <sl-detail-list-item labelStyle={diff('cocNo')} title="一致性证书编号">{renderItem('cocNo')}</sl-detail-list-item>
              <sl-detail-list-item labelStyle={diff('color')} title="车辆颜色">{renderItem('color')}</sl-detail-list-item>

              <sl-detail-list-item labelStyle={diff('category.name')} title="车辆类型">{renderItem('category.name')}</sl-detail-list-item>
              <sl-detail-list-item labelStyle={diff('license.licenseNo')} label="车牌号">{renderItem('license.licenseNo')}</sl-detail-list-item>
              <sl-detail-list-item labelStyle={diff('company.companyName')} label="所属企业">{renderItem('company.companyName')}</sl-detail-list-item>
              <sl-detail-list-item labelStyle={diff('enrollDatetime')} label="登记时间">{renderItem('enrollDatetimeText')}</sl-detail-list-item>

              <sl-detail-list-item labelStyle={diff('carNo')} title="车辆编号">{renderItem('carNo')}</sl-detail-list-item>
              <sl-detail-list-item labelStyle={diff('brand')} title="车辆品牌">{renderItem('brand')}</sl-detail-list-item>
              <sl-detail-list-item labelStyle={diff('imei')} title="IMEI">{renderItem('imei')}</sl-detail-list-item>
              <sl-detail-list-item labelStyle={diff('frameNo')} title="车架号">{renderItem('frameNo')}</sl-detail-list-item>

              <sl-detail-list-item labelStyle={diff('motorNo')} title="电机号">{renderItem('motorNo')}</sl-detail-list-item>
              <sl-detail-list-item labelStyle={diff('battery.specs')} title="电池规格">{renderItem('battery.specs')}</sl-detail-list-item>
              <sl-detail-list-item labelStyle={diff('battery.batteryNo')} title="电池序号">{renderItem('battery.batteryNo')}</sl-detail-list-item>
              <sl-detail-list-item labelStyle={diff('battery.brand')} title="电池品牌">{renderItem('battery.brand')}</sl-detail-list-item>

              <sl-detail-list-item labelStyle={diff('battery.typeText')} title="电池类型">{renderItem('battery.typeText')}</sl-detail-list-item>
              <sl-detail-list-item labelStyle={diff('battery.voltage')} title="电池电压">{renderItem('battery.voltage')}</sl-detail-list-item>
              <sl-detail-list-item labelStyle={diff('battery.electricity')} title="电池电量">{renderItem('battery.electricity')}</sl-detail-list-item>
              <sl-detail-list-item labelStyle={diff('insurance.insuranceNo')} label="保单号">{renderItem('insurance.insuranceNo')}</sl-detail-list-item>

              <sl-detail-list-item labelStyle={diff('buyOptions')} label="购车方案">{renderItem('buyOptionsText')}</sl-detail-list-item>
              {
                origin.buyOptions == 1 ? [
                  <sl-detail-list-item labelStyle={diff('billing.billingRuleId')} label="计费规则">{renderItem('ruleDisplay')}</sl-detail-list-item>,
                ] : null
              }
              <sl-detail-list-item labelStyle={diff('remark')} title="备注">{renderItem('remark')}</sl-detail-list-item>
              <sl-detail-list-item labelStyle={diff('photo')} title="图片">
                {
                  origin.photo == data.photo ? 
                    <sl-carousel images={origin.photo ? origin.photo.split(';') : []} /> : 
                    <div style="display:flex;align-items: center;">
                      <div style="min-width:200px"><sl-carousel images={origin.photo ? origin.photo.split(';') : []} /></div>
                      <Icon type="md-arrow-forward" style="margin:0 16px;" />
                      <div><sl-carousel images={data.photo ? data.photo.split(';') : []} /></div>
                    </div>
                }
              </sl-detail-list-item>
            </sl-detail-list>
          </div>
        </div>
        { footer } 
      </div>
    )
  }
}
